import React, {Component} from "react";
import {Route, Switch, Redirect, withRouter} from 'react-router-dom';
import './assets/css/theme/base.css';
import './assets/css/theme/login-6.css';
import './App.css';
import Login from "./components/Login/Login";
import UserPage from "./pages/UserPage";
import {AUTH_TOKEN} from "./shared/utility";
import Nav from "./components/Navbar/Nav";
import Footer from "./components/Footer/Footer";
import Logout from "./pages/Logout";
import ResetPassword from "./components/ResetPassword/ResetPassword";
import ChangePassword from "./components/ChangePassword/ChangePassword";
import AddAnnouncement from "./components/Announcement/AddAnnouncement"
import MyPublications from "./components/Announcement/MyPublications";
import AnnouncementPublicationDetails from "./components/Announcement/AnnouncementPublicationDetails";
import AllAnnouncementsPage from "./pages/AllAnnouncementsPage";
import AnnouncementToPublish from "./components/Announcement/AnnouncementToPublish";
import PublicationsForAnnouncements from "./components/Announcement/PublicationsForAnnouncements";
import AddAttachment from "./components/Announcement/AddAttachment";
import FeedbackToPublish from "./components/Feedback/FeedbackToPublish";
import FeedbackCrudTable from "./components/Feedback/FeedbackCrudTable";
import MyFeedbackPublications from "./components/Feedback/MyFeedbackPublications";
import DesignFeedbackItem from "./components/Feedback/DesignFeedbackItem";
import VisualizeFeedback from "./components/Feedback/VisualizeFeedback";
import VisualizeAnswers from "./components/Feedback/VisualizeAnswers";
import AnalyseFeedback from "./components/Feedback/AnalyseFeedback";
import PublicDocumentType from "./components/PublicDocumentType/PublicDocumentType";
import InstitutionCategoryCrudTable from "./components/InstitutionCategoryCrud/InstitutionCategoryCrudTable";
import AnnouncementPublicationReport from "./components/Announcement/AnnouncementPublicationReport";
import EditAnnouncement from "./components/Announcement/EditAnnouncement";
import FAQ from "./components/FAQ/FAQ";
import AddFAQ from "./components/FAQ/AddFAQ";
import EditFAQ from "./components/FAQ/EditFAQ";
import SidebarMenu from "./components/Sidebar/Sidebar"
import PreviewFeedback from "./components/Feedback/PreviewFeedback";
import Monitoring from "./components/PublicDocument/Monitoring";
import Tags from "./components/Tag/Tags";
import PublicDocument from "./components/PublicDocument/PublicDocument";
import AnnualReport from "./components/AnnualReport/AnnualReport"
import InactiveUsers from "./components/User/InactiveUsers";
import InstitutionTable from "./components/Institution/InstitutionTable";
import UsersTable from "./components/User/UsersTable";
import Question from "./components/Question/Question";
import EditQuestion from "./components/Question/EditQuestion";
import AddQuestion from "./components/Question/AddQuestion";
import QuestionDetails from "./components/Question/QuestionDetails";
import InactiveQuestions from "./components/Question/InactiveQuestions";
import EditMessage from "./components/Question/EditMessage";
import MyInstitution from "./components/Institution/MyInstitution";
import EditedInstitutions from "./components/Institution/EditedInstitutions";
import FullReport from "./components/FullReport/FullReport";
import ListOfReports from "./components/FullReport/ListOfReports";
import ListOfReportsForEvaluation from "./components/FullReport/ListOfReportsForEvaluation";
import EvaluationOfFullReport from "./components/FullReport/EvaluationOfFullReport";
import InstitutionResponsiblePersons from "./components/Institution/InstitutionResponsiblePersons";
import AddPublicDocument from "./components/PublicDocument/AddPublicDocument";
import SendRequest from "./components/SendingRequestEvaluation/SendRequest";
import AllRequestsPaged from "./components/SendingRequestEvaluation/AllRequestsPaged";
import CriteriaType from "./components/CriteriaType/CriteriaType";
import CriteriaTypeOptions from "./components/CriteriaTypeOptions/CriteriaTypeOptions";
import ResetPassNewPage from "./components/ResetPassword/ResetPassNewPage";
import ProactiveTransparencyCrudTable from "./components/ProactiveTransparency/ProactiveTransparencyCrudTable";
import DesignProactiveTransparency from "./components/ProactiveTransparency/DesignProactiveTransparency";
import ProactiveTransparencyToPublish from "./components/ProactiveTransparency/ProactiveTransparencyToPublish";
import ProactiveTransparencyFinished from "./components/ProactiveTransparency/ProactiveTransparencyFinished";
import PreviewAnsweredAndSendReport from "./components/ProactiveTransparency/PreviewAnsweredAndSendReport";
import PreviewProactiveTransparency from "./components/ProactiveTransparency/PreviewProactiveTransparency";
import MyProactiveTransparencyPublications
    from "./components/ProactiveTransparency/MyProactiveTransparencyPublications";
import TutorialVideo from "./components/Tutorial/TutorialVideo";


class App extends Component {
    constructor(props) {
        super(props);
        this.state = {
            role: "",
            data: {}

        }
    }

    render() {
        let routes = (
            <Switch>
                <Route path="/login/:pubid/:annid" exact component={Login}/>
                <Route path="/login" component={Login}/>
                <Route path="/FAQ" component={FAQ}/>
                <Route path="/reset/password" exact component={ResetPassword}/>
                <Route path="/reset/token/:token" exact component={ResetPassNewPage}/>
                <Redirect to="/login"/>
            </Switch>
        );
        let authToken = localStorage.getItem(AUTH_TOKEN);
        let userRole = localStorage.getItem('role');
        if (authToken && authToken !== '') {
            if (userRole === "ROLE_ADMIN") {
                routes = this.adminRoutes();
            } else if (userRole === "ROLE_INSTITUTIONAL_MODERATOR") {
                routes = this.moderatorRoutes();
            } else if (userRole === "ROLE_EVALUATOR") {
                routes = this.evaluatorRoutes();
            }
        }

        return (
            <div style={{height: "100%"}}>
                {routes}
            </div>
        )
    }

    adminRoutes = () => {
        return (
            <div style={{height: "100%"}}>

                <Nav/>

                <div style={{display: "flex", height: "100%"}}>
                    <SidebarMenu/>
                    <div className="container-fluid" style={{height: "100%", overflowY: "scroll"}}>
                        <Switch>
                            <Route path="/" exact component={AllAnnouncementsPage}/>
                            <Route path="/addannouncement" exact component={AddAnnouncement}/>
                            <Route path="/editAnnouncement/:id" component={EditAnnouncement}/>
                            <Route path="/mypublications" exact component={MyPublications}/>
                            <Route path="/myannouncements/:id" exact component={AnnouncementPublicationDetails}/>
                            <Route path="/allannouncements" exact component={AllAnnouncementsPage}/>
                            <Route path="/announcement/report" exact component={AnnouncementPublicationReport}/>
                            <Route path="/addattachment/:id" exact component={AddAttachment}/>
                            <Route path="/publish/:id" exact component={AnnouncementToPublish}/>
                            <Route path="/publications/:id" exact component={PublicationsForAnnouncements}/>
                            <Route path="/feedbacks" exact component={FeedbackCrudTable}/>
                            <Route path="/publishfeedback/:id" exact component={FeedbackToPublish}/>
                            <Route path="/myfeedbackpublications" exact component={MyFeedbackPublications}/>
                            <Route path="/desingfeedback/:id" exact component={DesignFeedbackItem}/>
                            <Route path="/previewfeedback/:id" exact component={PreviewFeedback}/>
                            <Route path="/visualizeFeedback/:id" exact component={VisualizeFeedback}/>
                            <Route path="/visualizeAnswers/:id" exact component={VisualizeAnswers}/>
                            <Route path="/analyse/:id" exact component={AnalyseFeedback}/>
                            <Route path="/login" component={Login}/>
                            <Route path="/users" exact component={UsersTable}/>
                            <Route path="/users/inactive/:id" exact component={InactiveUsers}/>
                            <Route path="/institutions" exact component={InstitutionTable}/>
                            <Route path="/tags" exact component={Tags}/>
                            <Route path="/publicdocument" exact component={PublicDocument}/>
                            <Route path="/monitoring" exact component={Monitoring}/>
                            <Route path="/publicdoctypes" exact component={PublicDocumentType}/>
                            <Route path="/logout" component={Logout}/>
                            <Route path="/changepassword" exact component={ChangePassword}/>
                            <Route path="/institutioncategory" exact component={InstitutionCategoryCrudTable}/>
                            <Route path="/FAQ" component={FAQ}/>
                            <Route path="/AddFAQ" component={AddFAQ}/>
                            <Route path="/EditFAQ" component={EditFAQ}/>
                            <Route path="/SidebarMenu" component={SidebarMenu}/>
                            <Route path="/AnnualReport" component={AnnualReport}/>
                            <Route path="/Question" component={Question}/>
                            <Route path="/EditQuestion" component={EditQuestion}/>
                            <Route path="/AddQuestion" component={AddQuestion}/>
                            <Route path="/previewQuestion/:id" exact component={QuestionDetails}/>
                            <Route path="/EditMessage" component={EditMessage}/>
                            <Route path="/EditedInstitutions" component={EditedInstitutions}/>
                            <Route path="/fullReport/:id" exact component={FullReport}/>
                            <Route path="/ListOfReports" component={ListOfReports}/>
                            <Route path="/allForEvaluation" component={ListOfReportsForEvaluation}/>
                            <Route path="/evaluationOfFullReport/:id" component={EvaluationOfFullReport}/>
                            <Route path="/responsiblePersons/:id" component={InstitutionResponsiblePersons}/>
                            <Route path="/sendRequest" component={SendRequest}/>
                            <Route path="/allRequests" component={AllRequestsPaged}/>
                            <Route path="/criteriaType" component={CriteriaType}/>
                            <Route path="/options/:id" component={CriteriaTypeOptions}/>
                            <Route path="/proactivity" exact component={ProactiveTransparencyCrudTable}/>
                            <Route path="/designTransparency/:id" exact component={DesignProactiveTransparency}/>
                            <Route path="/publishProactivity/:id" exact component={ProactiveTransparencyToPublish}/>
                            <Route path="/proactiveFinished/:id" exact component={ProactiveTransparencyFinished}/>
                            <Route path="/previewAndAnswer/:id" exact component={PreviewAnsweredAndSendReport}/>
                            <Route path="/previewTransparency/:id" exact component={PreviewProactiveTransparency}/>
                            <Route path="/tutorial" exact component={TutorialVideo}/>
                        </Switch>
                    </div>
                </div>

                <Footer/>

            </div>
        );
    };

    moderatorRoutes = () => {
        return (
            <div style={{height: "100%"}}>

                <Nav/>

                <div style={{display: "flex", height: "100%"}}>
                    <SidebarMenu/>
                    <div className="container-fluid" style={{height: "100%", overflowY: "scroll"}}>
                        <Switch>
                            <Route path="/" exact component={MyPublications}/>
                            <Route path="/mypublications" exact component={MyPublications}/>
                            <Route path="/myannouncements/:id" exact component={AnnouncementPublicationDetails}/>
                            <Route path="/addattachment/:id" exact component={AddAttachment}/>
                            <Route path="/publications/:id" exact component={PublicationsForAnnouncements}/>
                            <Route path="/myfeedbackpublications" exact component={MyFeedbackPublications}/>
                            <Route path="/visualizeFeedback/:id" exact component={VisualizeFeedback}/>
                            <Route path="/visualizeAnswers/:id" exact component={VisualizeAnswers}/>
                            <Route path="/login" component={Login}/>
                            <Route path="/users" exact component={UserPage}/>
                            <Route path="/publicdocument" exact component={PublicDocument}/>
                            <Route path="/logout" component={Logout}/>
                            <Route path="/changepassword" exact component={ChangePassword}/>
                            <Route path="/FAQ" component={FAQ}/>
                            <Route path="/AnnualReport" component={AnnualReport}/>
                            <Route path="/Question" component={Question}/>
                            <Route path="/EditQuestion" component={EditQuestion}/>
                            <Route path="/AddQuestion" component={AddQuestion}/>
                            <Route path="/previewQuestion/:id" exact component={QuestionDetails}/>
                            <Route path="/questions/inactive" exact component={InactiveQuestions}/>
                            <Route path="/EditMessage" component={EditMessage}/>
                            <Route path="/myInstitution" component={MyInstitution}/>
                            <Route path="/addPublicDocument/:id" component={AddPublicDocument}/>
                            <Route path="/myProactivityPublications" exact
                                   component={MyProactiveTransparencyPublications}/>
                            <Route path="/tutorial" exact component={TutorialVideo}/>
                        </Switch>
                    </div>
                </div>

                <Footer/>

            </div>

        );
    };


    evaluatorRoutes = () => {
        return (
            <div style={{height: "100%"}}>

                <Nav/>

                <div style={{display: "flex", height: "100%"}}>
                    <SidebarMenu/>
                    <div className="container-fluid" style={{height: "100%", overflowY: "scroll"}}>
                        <Switch>
                            <Route path="/" exact component={MyPublications}/>
                            <Route path="/mypublications" exact component={MyPublications}/>
                            <Route path="/myannouncements/:id" exact component={AnnouncementPublicationDetails}/>
                            <Route path="/addattachment/:id" exact component={AddAttachment}/>
                            <Route path="/publications/:id" exact component={PublicationsForAnnouncements}/>
                            <Route path="/myfeedbackpublications" exact component={MyFeedbackPublications}/>
                            <Route path="/visualizeFeedback/:id" exact component={VisualizeFeedback}/>
                            <Route path="/visualizeAnswers/:id" exact component={VisualizeAnswers}/>
                            <Route path="/login" component={Login}/>
                            <Route path="/users" exact component={UserPage}/>
                            <Route path="/publicdocument" exact component={PublicDocument}/>
                            <Route path="/logout" component={Logout}/>
                            <Route path="/changepassword" exact component={ChangePassword}/>
                            <Route path="/FAQ" component={FAQ}/>
                            <Route path="/AnnualReport" component={AnnualReport}/>
                            <Route path="/Question" component={Question}/>
                            <Route path="/EditQuestion" component={EditQuestion}/>
                            <Route path="/AddQuestion" component={AddQuestion}/>
                            <Route path="/previewQuestion/:id" exact component={QuestionDetails}/>
                            <Route path="/questions/inactive" exact component={InactiveQuestions}/>
                            <Route path="/EditMessage" component={EditMessage}/>
                            <Route path="/myInstitution" component={MyInstitution}/>
                            <Route path="/tutorial" exact component={TutorialVideo}/>
                        </Switch>
                    </div>
                </div>

                <Footer/>

            </div>

        );
    };

}

export default withRouter(App);

